import PainelAPI from '../../api/painel';

const state = {
  overview: null,
  pending: [],
  heatmap: null,
  nps: null,
  settings: null,
  uiFlags: {
    isFetchingOverview: false,
    isFetchingPending: false,
    isFetchingHeatmap: false,
    isFetchingNps: false,
    isFetchingSettings: false,
    isUpdatingSettings: false,
  },
};

const getters = {
  getOverview: $state => $state.overview,
  getPending: $state => $state.pending,
  getHeatmap: $state => $state.heatmap,
  getNps: $state => $state.nps,
  getUiFlags: $state => $state.uiFlags,
  getPainelSettings: $state => $state.settings,
  getStatusLabels: $state => ({
    pending: 'Pendente',
    confirmed: 'Confirmado',
    cancelled: 'Cancelado',
    ...($state.settings?.status_labels || {}),
  }),
  getStatusColors: $state => ({
    pending: 'amber',
    confirmed: 'teal',
    cancelled: 'ruby',
    ...($state.settings?.status_colors || {}),
  }),
};

const mutations = {
  SET_OVERVIEW($state, data) {
    $state.overview = data;
  },
  SET_PENDING($state, data) {
    $state.pending = data;
  },
  SET_HEATMAP($state, data) {
    $state.heatmap = data;
  },
  SET_NPS($state, data) {
    $state.nps = data;
  },
  SET_SETTINGS($state, data) {
    $state.settings = data;
  },
  SET_UI_FLAG($state, { flag, value }) {
    $state.uiFlags[flag] = value;
  },
};

const actions = {
  fetchOverview: async ({ commit }, params) => {
    commit('SET_UI_FLAG', { flag: 'isFetchingOverview', value: true });
    try {
      const { data } = await PainelAPI.overview(params);
      commit('SET_OVERVIEW', data);
    } catch (error) {
      commit('SET_OVERVIEW', null);
    } finally {
      commit('SET_UI_FLAG', { flag: 'isFetchingOverview', value: false });
    }
  },

  fetchPending: async ({ commit }) => {
    commit('SET_UI_FLAG', { flag: 'isFetchingPending', value: true });
    try {
      const { data } = await PainelAPI.pendingConversations();
      commit('SET_PENDING', data);
    } catch (error) {
      commit('SET_PENDING', []);
    } finally {
      commit('SET_UI_FLAG', { flag: 'isFetchingPending', value: false });
    }
  },

  fetchHeatmap: async ({ commit }, params) => {
    commit('SET_UI_FLAG', { flag: 'isFetchingHeatmap', value: true });
    try {
      const { data } = await PainelAPI.heatmap(params);
      commit('SET_HEATMAP', data);
    } catch (error) {
      commit('SET_HEATMAP', null);
    } finally {
      commit('SET_UI_FLAG', { flag: 'isFetchingHeatmap', value: false });
    }
  },

  fetchNps: async ({ commit }, params) => {
    commit('SET_UI_FLAG', { flag: 'isFetchingNps', value: true });
    try {
      const { data } = await PainelAPI.nps(params);
      commit('SET_NPS', data);
    } catch (error) {
      commit('SET_NPS', null);
    } finally {
      commit('SET_UI_FLAG', { flag: 'isFetchingNps', value: false });
    }
  },

  fetchSettings: async ({ commit }) => {
    commit('SET_UI_FLAG', { flag: 'isFetchingSettings', value: true });
    try {
      const { data } = await PainelAPI.fetchSettings();
      commit('SET_SETTINGS', data);
    } catch (error) {
      commit('SET_SETTINGS', null);
    } finally {
      commit('SET_UI_FLAG', { flag: 'isFetchingSettings', value: false });
    }
  },

  updateSettings: async ({ commit }, payload) => {
    commit('SET_UI_FLAG', { flag: 'isUpdatingSettings', value: true });
    try {
      const { data } = await PainelAPI.updateSettings(payload);
      commit('SET_SETTINGS', data);
    } finally {
      commit('SET_UI_FLAG', { flag: 'isUpdatingSettings', value: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
